import { Box } from "@mui/material";
import { ReactNode } from "react";
import { tokens } from "../../theme";

/**
 * Etiqueta del Design Kit (§04): rectángulo de radio 4, 12px/600.
 *
 * Las áreas y categorías son NEUTRAS: el kit no asigna un color por área, así
 * que no existe una paleta de categorías.
 */
export type VarianteEtiqueta = "neutra" | "acento" | "marca" | "contorno";

export default function Etiqueta({
  children,
  variante = "neutra",
  icono,
  truncar = false,
}: {
  children: ReactNode;
  variante?: VarianteEtiqueta;
  icono?: ReactNode;
  /** Recorta con "…" en vez de desbordar. Para columnas de ancho fijo, donde el
   *  nombre de un área larga se saldría de su celda. */
  truncar?: boolean;
}) {
  const t = tokens.etiqueta[variante];
  const borde = "borde" in t ? t.borde : undefined;

  return (
    <Box
      component="span"
      // Recortada, el nombre completo queda en el tooltip del navegador.
      title={truncar && typeof children === "string" ? children : undefined}
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        bgcolor: t.bg,
        color: t.fg,
        fontWeight: 600,
        fontSize: 12,
        padding: borde ? "4px 10px" : "5px 11px",
        borderRadius: "4px",
        border: borde ? `1px solid ${borde}` : undefined,
        whiteSpace: "nowrap",
        ...(truncar && { maxWidth: "100%", minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", display: "inline-block" }),
      }}
    >
      {icono}
      {children}
    </Box>
  );
}
